export const jkoaPurchaseYes = () => ({
    type: 'JKOA_ITEM_YES'
});

export const jkoaPurchaseNo = () => ({
    type: 'JKOA_ITEM_NO'
});